import { Injectable, inject } from '@angular/core';
import { NotificationService, NotificationServiceInjector } from '@next/core-lib/notification';
import { filter, map, Observable } from 'rxjs';

import type { FmsDiagnoseSyncStatus } from '../models/fms-diagnose.model';

export interface FmsSyncStatusUpdatedEvent {
  CustomerId: number;
  SyncStatus: FmsDiagnoseSyncStatus;
  SyncTaskCode: string;
  TimeStamp: Date | string;
}

@Injectable({ providedIn: 'root' })
export class FmsSyncNotificationService {
  private readonly notificationService = inject<NotificationService>(NotificationServiceInjector);

  readonly events$ = this.notificationService
    .on<FmsSyncStatusUpdatedEvent | string>('Arable_FmsSyncStatusUpdatedEvent')
    .pipe(
      map((event) => {
        if (typeof event !== 'string') {
          return event;
        }

        try {
          return JSON.parse(event) as FmsSyncStatusUpdatedEvent;
        } catch {
          return null;
        }
      }),
      filter((event): event is FmsSyncStatusUpdatedEvent => event !== null),
    );

  eventsForCustomer(customerId: number): Observable<FmsSyncStatusUpdatedEvent> {
    return this.events$.pipe(filter((event) => event.CustomerId === customerId));
  }
}
